module.exports = __webpack_public_path__ + "img/dmp2.022df15b.png";